import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { axiosInstance } from '../api';
import AuthenticationService from '../services/AuthenticationService';

export const useAxiosInterceptors = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // const requestInterceptor = axiosInstance.interceptors.request.use(
        // );

        const responseInterceptor = axiosInstance.interceptors.response.use(
            (response) => {
                return response;
            },
            (error) => {
                if (error.response?.status === 403) {
                    console.log('path', location.pathname);
                    if (location.pathname.includes('admin/')) {
                        AuthenticationService.logoutAdmin();
                        navigate('/admin/login', { replace: true });
                    } else {
                        AuthenticationService.logoutFundraiser();
                        navigate('/fundraiser/login', { replace: true });
                    }
                }

                return Promise.reject(error);
            }
        );

        // Return cleanup function to remove interceptors if necessary
        return () => {
            // axiosInstance.interceptors.request.eject(requestInterceptor);
            axiosInstance.interceptors.response.eject(responseInterceptor);
        };
    }, []);
};
